import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingBag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "46px",
	height: "56px",
	viewBox: "0 0 46 56",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Group" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Tablet",
				transform: "translate(-236.000000, -48.000000)",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group",
					transform: "translate(236.000000, 48.000000)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M13.83658,1.07266 L13.83658,46.23816 L15.18382,56.1629 L10.39116,42.84146 L10.39116,4.94702 L13.83658,1.07266 Z M9.44012,43.63757 L14.31467,55.27233 L1.45777,52.55536 L9.44012,43.63757 Z M1.88374,43.11817 L2.65714,4.49589 L9.66932,5.32369 L9.66932,41.82473 L0.2596,52.0688 L1.88374,43.11817 Z",
							id: "Shape",
							fill: "#FFFFFF"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "Path",
							fill: "#FFFFFF",
							points: "16.3077 55.43155 14.5356 44.22987 14.5356 0.51537 43.42287 3.69046 43.42287 39.12434 45.04929 47.60814"
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Heart-Copy",
							transform: "translate(22.000000, 22.000000)",
							fill: "#959595",
							children: /* @__PURE__ */ _jsx("path", {
								d: "M7.47619047,1.75942151 C6.90047089,1.02283409 5.78681855,0 4.03571732,0 C1.78574459,0 0,1.97061883 0,3.91912358 C0,5.86821675 1.00278795,7.39432686 3.00899498,9.15025435 C5.00827174,10.9009457 5.69485166,11.0772364 7.46737085,12 C9.25815233,11.0772364 9.94536338,10.9009457 11.9440131,9.15025435 C13.9502201,7.39432686 14.9523809,5.86821675 14.9523809,3.91912358 C14.9523809,1.97061883 13.1672634,0 10.9166636,0 C9.16619352,0 8.05191007,1.02283409 7.47619047,1.75942151 Z",
								id: "Path"
							})
						})
					]
				})
			})
		})
	]
});
export default SvgShoppingBag;
